module.exports = __webpack_public_path__ + "img/profile.981a793c.svg";